import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import enGB from 'antd/locale/en_GB'
import _ from 'lodash'
import { Formik, ErrorMessage } from 'formik'
import { Form, Field } from 'formik-antd'
import 'moment/locale/en-gb'
import moment from 'moment'
import { saveAs } from 'file-saver'
// import 'antd/dist/antd.css'
import SelectCompAntd from '../common/SelectCompAntd'
import { message, Select, DatePicker } from 'antd'
import { reportService } from '../../_services/report.service'

const { Option } = Select

const branchDefault = 'all'
const departmentDefault = 'all'
const periodDefault = 'weekly'
const reportDefault = 'pdf'

moment.locale('en-nz')

const rangeTypes = {
    WEEKLY: 'weekly',
    CUSTOM: 'custom',
}

class DownloadModal extends PureComponent {
    state = {
        visible: false,
        displayLabel: '',
        current: moment(new Date()),
        dateFrom: '',
        dateTo: '',
        reportType: 'all',
        startValue: null,
        endValue: null,
        endOpen: false,
        selectedPeriod: 'weekly',
        displayEmployees: this.props.employees,
        selectedBranch: 'all',
        selectedDepartment: 'all',
        selectedEmployees: [],
    }

    handleChange = (e, form) => {
        form.setFieldValue('period', e)
    }

    handleVisibleChange = visible => {
        this.setState({ visible })
    }

    disabledStartDate = startValue => {
        const { endValue } = this.state
        if (!startValue || !endValue) {
            return false
        }
        return startValue.valueOf() > endValue.valueOf()
    }

    disabledEndDate = endValue => {
        const { startValue } = this.state
        if (!endValue || !startValue) {
            return false
        }
        return endValue.valueOf() <= startValue.valueOf()
    }

    onChange = (date, dateString, form) => {
        form.setFieldValue('week', date)
    }

    onRangeChange = (date, dateString, form) => {
        form.setFieldValue('range', date)
    }

    onStartChange = (values, form) => {
        // console.log();
        this.onChange('startValue', values)
    }

    onEndChange = value => {
        this.onChange('endValue', value)
    }

    handleStartOpenChange = open => {
        if (!open) {
            this.setState({ endOpen: true })
        }
    }

    handleEndOpenChange = open => {
        this.setState({ endOpen: open })
    }

    createAndDownloadPdf = async (data, setSubmitting) => {
        try {
            const report = await reportService.fetchPdfReportData(data)
            const pdfBlob = new Blob([report.data], { type: 'application/pdf' })
            const fileURL = URL.createObjectURL(pdfBlob)
            window.open(fileURL)
            setSubmitting(false)
            this.props.onHide()
        } catch (err) {
            message.error('Report error, please try again later')
        }

        // fetch('/api/report/roster-report/etime/pdf', {
        //     headers: {
        //         'Content-Type': 'application/json',
        //     },
        //     body: JSON.stringify(data),
        //     method: 'POST',
        // })
        //     .then(res => {
        //         return res.arrayBuffer().then(res => {
        //             const pdfBlob = new Blob([res], { type: 'application/pdf' })
        //             const fileURL = URL.createObjectURL(pdfBlob)
        //             window.open(fileURL)
        //         })
        //     })
        //     .catch(error => {
        //         console.log(`error=${error}`)
        //     })
        //     .then(() => {
        //         setSubmitting(false)
        //     })
    }

    createAndDownloadExcel = async (data, setSubmitting) => {
        try {
            const report = await reportService.fetchExcelReportData(data)
            const blob = new Blob([report.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
            saveAs(blob, 'Report.xlsx')
            // const fileURL = URL.createObjectURL(pdfBlob)
            // window.open(fileURL)
            setSubmitting(false)
            this.props.onHide()
        } catch (err) {
            message.error('Report error, please try again later')
        }
        // fetch('/api/report/roster-report/etime/excel', {
        //     headers: {
        //         'Content-Type': 'application/json',
        //     },
        //     body: JSON.stringify(data),
        //     method: 'POST',
        //     responseType: 'arraybuffer',
        // })
        //     .then(res => {
        //         return res.arrayBuffer().then(res => {
        //             var blob = new Blob([res], {
        //                 type:
        //                     'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        //             })
        //             saveAs(blob, 'Report.xlsx')
        //         })
        //     })
        //     .catch(error => {
        //         console.log(`error=${error}`)
        //     })
        //     .then(() => {
        //         setSubmitting(false)
        //     })
    }

    handleFormSubmit = async (data, setSubmitting) => {
        const { employees, period, week, range, rptType } = data

        // const branchId =
        //     branches === branchDefault ? branchDefault : branches

        // const branchName = _.head(
        //     _.filter(this.props.branches, item => {
        //         return item.id === branchId
        //     })
        // )['label']

        // const departmentId =
        //     departments === departmentDefault
        //         ? departmentDefault
        //         : departments

        // const departmentName = _.head(
        //     _.filter(this.props.departments, item => {
        //         return item.id === departmentId
        //     })
        // )['label']

        const bodyData = {
            employees: employees,
            period: period,
            week: week,
            range: range,
            rptType: rptType,
        }

        switch (rptType) {
            case 'pdf':
                {
                    await this.createAndDownloadPdf(bodyData, setSubmitting)
                }
                break

            case 'excel':
                {
                    await this.createAndDownloadExcel(bodyData, setSubmitting)
                }
                break
            default: {
                console.log(`error=no report type specified`)
            }
        }

    }

    employeeOptions = empList => {
        return empList.map(emp => {
            return { label: emp.EmployeeName, id: emp.EmployeeAutoID }
        })
    }

    onChange = (date, dateString) => {
        console.log(date, dateString)
    }

    updateDisplayEmployee = cond => {
        const { employees } = this.props

        const filteredEmployees = _.filter(employees, cond)
        this.setState({ displayEmployees: filteredEmployees })
    }

    handleBranchChange = branch => {
        const { selectedDepartment } = this.state
        let filterCond = {}
        if (branch !== 'all') {
            filterCond.EmployeeBranch = branch
        }
        if (selectedDepartment && selectedDepartment !== 'all') {
            filterCond.EmployeeDepartment = selectedDepartment
        }

        this.setState({
            selectedBranch: branch,
        })
        this.updateDisplayEmployee(filterCond)
    }
    handleDepartmentChange = department => {
        const { selectedBranch } = this.state

        let filterCond = {}
        if (department !== 'all') {
            filterCond.EmployeeDepartment = department
        }
        if (selectedBranch && selectedBranch !== 'all') {
            filterCond.EmployeeBranch = selectedBranch
        }

        this.setState({
            selectedDepartment: department,
        })
        this.updateDisplayEmployee(filterCond)
    }

    // handleEmployeeChange = value => {
    //     this.setState({ selectedEmployees: value })
    // }

    handleEmployeeChange = (e, form) => {
        form.setFieldValue('employees', e)
    }

    handleTypeChange = (e, form) => {
        form.setFieldValue('rptType', e)
    }

    displayEmployees = () => {
        const empOption = this.props.employees.map(emp => {
            let o = {}
            o.label = emp.EmployeeName
            o.value = emp.key
            return o
        })

        return empOption
    }

    render() {
        const today = new Date()
        const startDate = moment(today).startOf('isoweek')
        const endDate = moment(today).endOf('isoweek')
        const { selectedPeriod } = this.state

        return (
            <div>
                <Formik
                    initialValues={{
                        employees: [],
                        week: moment(today),
                        range: [startDate, endDate],
                        period: periodDefault,
                        rptType: reportDefault,
                    }}
                    onSubmit={(values, { setSubmitting }) => {
                        setTimeout(() => {
                            this.handleFormSubmit(values, setSubmitting)
                        }, 400)
                    }}
                >
                    {report => (
                        <Form layout="vertical">
                            <div className="modal-body">
                                <div className="container-fluid">
                                    <div className="row form-group">
                                        <div className="col-sm-10 col-md-10 padright15">
                                            <Form.Item
                                                name="employee"
                                                label="Employee"
                                                initialValue=""
                                            >
                                                <Select
                                                    id="employees"
                                                    name="employees"
                                                    mode="multiple"
                                                    allowClear
                                                    style={{
                                                        width: '100%',
                                                    }}
                                                    dropdownStyle={{
                                                        zIndex: 1102,
                                                    }}
                                                    placeholder="Select employees"
                                                    defaultValue={[]}
                                                    onChange={e =>
                                                        this.handleEmployeeChange(
                                                            e,
                                                            report
                                                        )
                                                    }
                                                    options={this.displayEmployees()}
                                                    value={
                                                        report.values.employees
                                                    }
                                                    maxTagCount="responsive"
                                                    filterOption={(
                                                        input,
                                                        option
                                                    ) =>
                                                        (option?.label ?? '')
                                                            .toLowerCase()
                                                            .includes(
                                                                input.toLowerCase()
                                                            )
                                                    }
                                                />
                                            </Form.Item>
                                            {/* <SelectCompAntd
                                                name="employees"
                                                readOnly={true}
                                                showSearch={false}
                                                placeholder="-- All Employees --"
                                                className="form-control"
                                                data={this.employeeOptions(
                                                    this.state.displayEmployees
                                                )}
                                                mode="multiple"
                                                maxTagTextLength={20}
                                                maxTagCount={2}
                                                allowClear={true}
                                                handleChange={this.handleEmployeeChange.bind(
                                                    this
                                                )}
                                            ></SelectCompAntd> */}
                                        </div>
                                    </div>

                                    <div className="row form-group">
                                        <div className="col-sm-6 col-md-6 padright15">
                                            <div className="form-group">
                                                <label
                                                    htmlFor="period"
                                                    className="control-label"
                                                >
                                                    Period
                                                </label>
                                                <Select
                                                    name="period"
                                                    readOnly
                                                    dropdownStyle={{
                                                        zIndex: 1102,
                                                    }}
                                                    placeholder="Select Report Period"
                                                    className="form-control"
                                                    defaultValue={'weekly'}
                                                    onChange={e =>
                                                        this.handleChange(
                                                            e,
                                                            report
                                                        )
                                                    }
                                                >
                                                    <Option value="weekly">
                                                        Weekly
                                                    </Option>
                                                    <Option value="custom">
                                                        Custom
                                                    </Option>
                                                </Select>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row form-group">
                                        <div className="col-sm-10 col-md-10 padright15">
                                            {report.values.period ===
                                                rangeTypes.WEEKLY && (
                                                <DatePicker
                                                    name="week"
                                                    popupStyle={{
                                                        zIndex: 1102,
                                                    }}
                                                    onChange={(
                                                        date,
                                                        dateString
                                                    ) =>
                                                        this.onChange(
                                                            date,
                                                            dateString,
                                                            report
                                                        )
                                                    }
                                                    value={report.values.week}
                                                    inputReadOnly={true}
                                                    locale={enGB}
                                                />
                                            )}
                                            {report.values.period ===
                                                rangeTypes.CUSTOM && (
                                                <DatePicker.RangePicker
                                                    name="range"
                                                    popupStyle={{
                                                        zIndex: 1102,
                                                    }}
                                                    onChange={(
                                                        date,
                                                        dateString
                                                    ) =>
                                                        this.onRangeChange(
                                                            date,
                                                            dateString,
                                                            report
                                                        )
                                                    }
                                                    inputReadOnly={true}
                                                    locale={enGB}
                                                />
                                            )}
                                        </div>
                                    </div>

                                    <div className="row form-group">
                                        <div className="col-sm-6 col-md-6 padright15">
                                            <label
                                                htmlFor="rptType"
                                                className="control-label"
                                            >
                                                Report Type
                                            </label>
                                            <Select
                                                name="rptType"
                                                dropdownStyle={{ zIndex: 1102 }}
                                                defaultValue={
                                                    report.values.rptType
                                                }
                                                value={
                                                    report.values.rptType
                                                }
                                                onChange={e =>
                                                    this.handleTypeChange(
                                                        e,
                                                        report
                                                    )
                                                }
                                                readOnly
                                                placeholder="Select Report Type"
                                                className="form-control"
                                            >
                                                <Option value="pdf">PDF</Option>
                                                <Option value="excel">
                                                    Excel
                                                </Option>
                                            </Select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="submit"
                                    className="btn btn-success pull-left btn-md-w"
                                    disabled={report.isSubmitting}
                                >
                                    Download
                                </button>
                            </div>
                        </Form>
                    )}
                </Formik>
            </div>
        )
    }
}

function mapSteteToProps(state) {
    return {
        employees: state.roster.employeeList,
        branches: state.BranchReducer.branchList,
        departments: state.DepartmentReducer.departmentList,
    }
}

export default connect(mapSteteToProps)(DownloadModal)
